
//import { Form } from 'Components';
import { Form } from '@cae/component-library';
import { ErrorModel } from 'Models';

export const ValidateFormFields = (form : Form): ErrorModel[] => {

    const errors : ErrorModel[] = [];
    Object.keys(form).forEach(key => {
        const formField = form[key];
        const reasons: string[] = [];
        let performValidation: boolean = true;
        
        if (formField.validateOnCondition) {
            const condition = formField.validateOnCondition(form);
            performValidation = condition.shouldValidateField;
        }

        if (performValidation) {
            formField.validations.forEach(validation => {
                if (!formField.value.toString().match(validation.regex)) {
                    reasons.push(validation.reason);
                }
            });
        }

        if (reasons.length > 0) {
            errors.push(new ErrorModel({ key: key, reasons }));
        }
    });
    return errors;
}
